import React from 'react';
import { ProtectedRoute, PermissionRoute, PublicRoute, AdminRoute } from './RouteGuards';

// Public pages
import LandingPage from '../modules/public/pages/LandingPage';
import LoginPage from '../modules/public/pages/LoginPage';
import SignUpPage from '../modules/public/pages/SignUpPage';
import RulesPage from '../modules/public/pages/RulesPage';
import HelpPage from '../modules/public/pages/HelpPage';
import ForgotPasswordPage from '../modules/public/pages/ForgotPasswordPage';

// Strava
import StravaCallbackPage from '../modules/strava/pages/StravaCallbackPage';

// Protected pages
import FitHub from '../modules/dashboard/pages/FitHub';
import CompetitionPage from '../modules/competition/pages/CompetitionPage';
import CompetitionStatsPage from '../modules/competition/pages/StatisticsPage';
import CreateCompetitionPage from '../modules/competition/pages/CreateCompetitionPage';
import EditCompetitionPage from '../modules/competition/pages/EditCompetitionPage';
import ProfilePage from '../modules/profile/pages/ProfilePage';
import FeedPage from '../modules/feed/pages/FeedPage';
import ActivityPage from '../modules/activity/pages/ActivityPage';
import CompetitionsOverview from '../modules/competition/pages/CompetitionsOverview';
import CompetitorsOverview from '../modules/competitors/pages/CompetitorsOverview';
import MapPage from '../modules/map/pages/MapPage';

// Admin
import AdminDashboard from '../modules/admin/pages/AdminDashboard';
import AdminExemptions from '../modules/admin/pages/AdminExemptions';
import AdminUsers from '../modules/admin/pages/AdminUsers';
import AdminActivities from '../modules/admin/pages/AdminActivities';
import AdminCompetitions from '../modules/admin/pages/AdminCompetitions';
import AdminStrava from '../modules/admin/pages/AdminStrava';
import AdminLayout from '../modules/admin/components/AdminLayout';

const stravaEnabled = process.env.REACT_APP_FEATURE_STRAVA === 'true';

export const routes = [
    // Public Routes
    {
        path: '/',
        element: (
            <PublicRoute>
                <LandingPage />
            </PublicRoute>
        )
    },
    {
        path: '/login',
        element: (
            <PublicRoute>
                <LoginPage />
            </PublicRoute>
        )
    },
    {
        path: '/signup',
        element: (
            <PublicRoute>
                <SignUpPage />
            </PublicRoute>
        )
    },
    {
        path: '/rules',
        element: (
            <PublicRoute>
                <RulesPage />
            </PublicRoute>
        )
    },
    {
        path: '/help',
        element: (
            <PublicRoute>
                <HelpPage />
            </PublicRoute>
        )
    },
    {
        path: '/forgot-password',
        element: (
            <PublicRoute>
                <ForgotPasswordPage />
            </PublicRoute>
        )
    },

    // Strava callback - public so ProtectedRoute doesn't redirect to /login and lose the code/state params
    ...(stravaEnabled ? [{
        path: '/strava/callback',
        element: (
            <PublicRoute>
                <StravaCallbackPage />
            </PublicRoute>
        )
    }] : []),

    // Protected Routes
    {
        path: '/fithub',
        element: (
            <ProtectedRoute>
                <FitHub />
            </ProtectedRoute>
        )
    },
    {
        path: '/competition/:id',
        element: (
            <ProtectedRoute>
                <CompetitionPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/competitions',
        element: (
            <ProtectedRoute>
                <CompetitionsOverview />
            </ProtectedRoute>
        )
    },
    {
        path: '/competitions/create',
        element: (
            <PermissionRoute permission="competition:create">
                <CreateCompetitionPage />
            </PermissionRoute>
        )
    },
    {
        path: '/competition/:id/edit',
        element: (
            <PermissionRoute permission="competition:edit">
                <EditCompetitionPage />
            </PermissionRoute>
        )
    },
    {
        path: '/competitors',
        element: (
            <ProtectedRoute>
                <CompetitorsOverview />
            </ProtectedRoute>
        )
    },
    {
        path: '/competition/:id/stats',
        element: (
            <ProtectedRoute>
                <CompetitionStatsPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/map',
        element: (
            <ProtectedRoute>
                <MapPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/profile/:username',
        element: (
            <ProtectedRoute>
                <ProfilePage />
            </ProtectedRoute>
        )
    },
    {
        path: '/activities',
        element: (
            <ProtectedRoute>
                <FeedPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/activities/:username',
        element: (
            <ProtectedRoute>
                <FeedPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/activity/:id',
        element: (
            <ProtectedRoute>
                <ActivityPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/activity',
        element: (
            <ProtectedRoute>
                <ActivityPage />
            </ProtectedRoute>
        )
    },
    {
        path: '/admin',
        element: (
            <AdminRoute>
                <AdminLayout title="Admin Dashboard">
                    <AdminDashboard />
                </AdminLayout>
            </AdminRoute>
        )
    },
    {
        path: '/admin/exemptions',
        element: (
            <AdminRoute>
                <AdminLayout title="Exemptions">
                    <AdminExemptions />
                </AdminLayout>
            </AdminRoute>
        )
    },
    {
        path: '/admin/users',
        element: (
            <AdminRoute>
                <AdminLayout title="Users">
                    <AdminUsers />
                </AdminLayout>
            </AdminRoute>
        )
    },
    {
        path: '/admin/competitions',
        element: (
            <AdminRoute>
                <AdminLayout title="Competitions">
                    <AdminCompetitions />
                </AdminLayout>
            </AdminRoute>
        )
    },
    {
        path: '/admin/activities',
        element: (
            <AdminRoute>
                <AdminLayout title="Activities">
                    <AdminActivities />
                </AdminLayout>
            </AdminRoute>
        )
    },
    ...(stravaEnabled ? [{
        path: '/admin/strava',
        element: (
            <AdminRoute>
                <AdminLayout title="Strava Resync">
                    <AdminStrava />
                </AdminLayout>
            </AdminRoute>
        )
    }] : []),
];